/** Same ids as backend MUSCLE_GROUPS. */
export const MUSCLE_GROUPS = [
  "chest",
  "back",
  "shoulders",
  "biceps",
  "triceps",
  "legs",
  "glutes",
  "core",
  "cardio",
  "full_body",
  "other",
] as const;

export type MuscleGroupId = (typeof MUSCLE_GROUPS)[number];

export function isMuscleGroupId(v: string): v is MuscleGroupId {
  return (MUSCLE_GROUPS as readonly string[]).includes(v);
}

export function muscleGroupChipClass(_id: string, active = true): string {
  return active ? "tg-chip is-active" : "tg-chip";
}
